var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-column"},[_c('BankList'),_c('MainButton',{attrs:{"disabled":_vm.bankNotSelected,"routeTo":"StandingOrderConfirmation"}},[_vm._v(" continue ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }